<template>
  <div class="row format-width">
    <div class="col-12">
      <PageTitle title="Relatório Google Analytics" />  
    </div>

    <div class="col-sm-12 col-md-5 col-lg-5 mt-4">
      <label>Data início</label>
      <input type="date" class="form-control" v-model="data.start">
    </div>

    <div class="col-sm-12 col-md-5 col-lg-5 mt-4">
      <label>Data fim</label>
      <input type="date" class="form-control" v-model="data.end">
    </div>

    <div class="col-sm-12 col-md-2 col-lg-2 mt-4 d-flex flex-column">
      <button
        class="btn btn-success btn-block mt-auto"
        @click="getAnalytics"
      >
        Filtrar
      </button>
    </div>

    <div class="col-12">
      <div class="row">

        <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
          <b-card title="Utilizadores ativos">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #965ca0">
                  <i class="fas fa-globe-americas"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{results.activeUsers ? results.activeUsers : '0'}}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
          <b-card title="Quantidade de eventos">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #fc8d83">
                  <i class="fas fa-clipboard-list"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{results.eventCount ? results.eventCount : '0'}}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
          <b-card title="Utilizadores novos">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #e36b9b">
                  <i class="fas fa-users"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{results.newUsers ? results.newUsers : '0'}}</h2>
              </div>
            </div>
          </b-card>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
          <h4>Quantidade de eventos por Nome do evento</h4>
          <div style="max-height: 400px; overflow-y: auto;">
            <table class="table table-striped table-bordered mt-2">
              <thead>
                <tr>
                  <th>Nome do evento</th>
                  <th>Quantidade de eventos</th>
                  <th>Total de utilizadores</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in eventName" :key="i">
                  <td>{{item.eventName}}</td>
                  <td>{{item.eventCount}}</td>
                  <td>{{item.activeUsers}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
          <h4>Visualizações título da página</h4>
          <div style="max-height: 400px; overflow-y: auto;">
            <table class="table table-striped table-bordered mt-2">
              <thead>
                <tr>
                  <th>Título da página</th>
                  <th>Visualizações </th>
                  <th>Ativos</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in pages" :key="i">
                  <td>{{item.pageTitle}}</td>
                  <td>{{item.screenPageViews}}</td>
                  <td>{{item.activeUsers}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import { mapState } from 'vuex';
import UserTypes from '@/enums/UserTypes';

export default {
  components: {
    PageTitle
  },
  data() {
    return {
      data: {
        start: '',
        end: '',
        usuario_id: null
      },
      results: {},
      eventName: [],
      pages: [],
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.data.usuario_id = this.userTypeId()
  },

  methods: {
    getAnalytics() {
      if (this.data.start === '' || this.data.end === '') {
        this.makeToast('Ops!', 'Informe as datas para buscar os dados!', 'danger');
        return;
      }

      this.results = {};
      this.eventName = [];
      this.pages = [];

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getGoogleAnalytics', this.data)
        .then((response) => {
          if(response.data.cards) {
            this.results = response.data.cards;
            this.eventName = response.data.eventName;
            this.pages = response.data.pages;
          }
        })
        .catch(() => {
          this.makeToast('Ops!', 'Não foi possível buscar os dados!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
  },
};
</script>

<style scoped>
.btn-ads {
  width: 50px;
  height: 50px;
  border-radius: 40px;
  border: none;
}
@media (min-width: 768px) {
.format-width {
  margin-right: 10px;
}
}
</style>
